export enum PropertyCatalogItemsMoveTo {
    CATALOG = 'catalog',
    ORDER = 'order',
    INVENTORY = 'inventory',
}
